import { IconBrandFacebook, IconBrandX } from '@tabler/icons-react';
import { Linkedin } from 'lucide-react';

function SocialMediaShare({ url }) {
    const encodedURL = encodeURI(url);

    const socialMediaArray = [
        {
            socialMedia: 'x',
            url: 'https://twitter.com/intent/tweet?text=' + encodedURL,
            icon: IconBrandX
        },
        {
            socialMedia: 'linkedin',
            url: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedURL,
            icon: Linkedin
        },
        {
            socialMedia: 'facebook',
            url: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedURL,
            icon: IconBrandFacebook
        }
    ];

    return (
        <div className="flex gap-4">
            {socialMediaArray.map(({ socialMedia, url, icon: Icon }) => (
                <a key={socialMedia} href={url} target="_blank">
                    <Icon className="hover:text-fuschia" />
                </a>
            ))}
        </div>
    );
}

export default SocialMediaShare;
